module.exports = __webpack_public_path__ + "static/media/hcrimaging_logo.a9ac33f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hcrimaging_logo.png
// module id = 1483
// module chunks = 0